import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';

import Input from './Input';
import FormHint from 'common/components/styleguide/form/_helpers/FormHint';
import FormError from 'common/components/styleguide/form/_helpers/FormError';
import FormLabel from 'common/components/styleguide/form/_helpers/FormLabel';

const StyledInputGroup = styled.div`
  display: flex;
  flex-direction: ${({ isInline }) => (isInline ? 'row' : 'column')};
  align-items: ${({ isInline }) => (isInline ? 'center' : 'flex-start')};
  margin-bottom: ${({ inputType }) => ((inputType === 'hidden') ? '0px' : '20px')};
`;

const StyledInputWrapper = styled.div`
  width: ${({ isInline }) => (isInline ? 'auto' : '100%')};
  flex: ${({ isInline }) => (isInline ? 1 : 'auto')};
  margin-right: ${({ isInline }) => (isInline ? '10px' : 0)};
`;

const StyledInput = styled(Input)`
  && {
    width: 100%;
    flex: auto;
    border-color: ${({ theme, error }) => (error ? _.get(theme, 'colors.danger', null) : null)};
    color: ${({ theme, error }) => (error ? _.get(theme, 'colors.danger', null) : null)};
  }
`;

const InputGroup = React.forwardRef(({ className, inputProps, label = '', error = '', hint = '', center = false, isInline = false, inputSize = 'normal', inputRef = null }, ref) => {
  const classNames = [];
  const inputType = _.get(inputProps, 'type', null);
  if (className) {
    classNames.push(className);
  }
  return (
    <StyledInputGroup ref={ref} className={classNames.join(' ')} error={error} isInline={isInline} center={center} inputType={inputType}>
      {label ? (
        <FormLabel isInline={isInline} error={error} htmlFor={inputProps && inputProps.id ? inputProps.id : ''}>
          {label}
        </FormLabel>
      ) : (
        ''
      )}
      <StyledInputWrapper isInline={isInline}>
        <StyledInput error={error} isInline={isInline} inputSize={inputSize} ref={inputRef} {...inputProps} />
        {error ? <FormError isInline={isInline}>{error}</FormError> : null}
        {hint ? <FormHint isInline={isInline}>{hint}</FormHint> : null}
      </StyledInputWrapper>
    </StyledInputGroup>
  );
});

export default React.memo(InputGroup);
